import View from "../framework/view";
import template from "../../pugc/casual-driver";
import Server from "../server";
import {User} from "../bo/user";
import {toCanvas} from "qrcode";
import jQuery from "jquery";
import Alerts from "../misc/alerts";


const classname = "casual-driver-view";

export class CasualDriverView extends View {

    private user: User;
    private loginUrl: string | undefined

    constructor(user: User) {
        super(classname);
        this.user = user;
        Server.instance().getCasualDriverLogin(user.username as string).then(loginUrl => {
            this.loginUrl = loginUrl;
            this.update();
        })
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            user: this.user,
            loginUrl: this.loginUrl
        };

        const out = this.pug(template, data);

        this.afterUpdate(() => {
            const width = this.elt().find(".qrcode").width();
            const canvases = this.elt().find("canvas");
            canvases.each((idx, c) => {
                const canvas = jQuery(c);
                const url = canvas.data("url");
                console.log("canvas width ", width);
                toCanvas(c, url, {
                    errorCorrectionLevel: "high",
                    width: width
                }, (err) => console.log(err))
            });
        });

        return out;
    }


    async sendSMS() {
        const phone = this.elt().find("input[name='phone']").val() as string;
        if (! phone) {
            return;
        }
        const result = await Server.instance().sendCasualDriverSMS({username: this.user.username as string, phone: phone});

        if (result) {
            Alerts.alert("SMS sent");
        } else {
            Alerts.alert("SMS send failure");
        }
    }

}

View.on(
    "." + classname,
    "click",
    ".send-sms",
    function(that: CasualDriverView, event, elt) {
        that.sendSMS();
    });

